import type { GeminiSemanticEvent } from './realtime-session.js';

export class GeminiUiEvents {
  private playing = false;
  private thinking = false;
  constructor(private readonly ui: {
    pushTranscript(speaker: 'user' | 'merlin', text: string, finished: boolean): void;
    commitTurn(speaker: 'user' | 'merlin'): void;
    flushPanels(): void;
    setActivity(state: 'speaking' | 'thinking' | 'listening'): void;
  }) {}
  handle(event: GeminiSemanticEvent): void {
    switch (event.type) {
      case 'transcript': this.ui.pushTranscript(event.role === 'assistant' ? 'merlin' : 'user', event.text, event.finished); return;
      case 'turn_complete': this.ui.flushPanels(); this.ui.commitTurn('merlin'); this.ui.commitTurn('user'); return;
      case 'interrupted':
        this.playing = false; this.thinking = false; this.ui.flushPanels(); this.ui.commitTurn('merlin'); break;
      case 'interaction_status': this.thinking = event.status === 'IN_PROGRESS'; break;
      case 'playback_state': this.playing = event.playing; break;
    }
    this.restoreActivity();
  }
  restoreActivity(): void { this.ui.setActivity(this.playing ? 'speaking' : this.thinking ? 'thinking' : 'listening'); }
}
